import { startSpan } from "@/lib/lazySentry";
import { toast } from "react-toastify";
import api from "@/services/MadUnicorn";

export const getImage = async ({ id }) => {
  return startSpan({ name: "GET mad-unicorn image" }, () =>
    api.get(`/api/images/${id}`).then((res) => res.data)
  );
};

export const getDesignSegmentations = async (design_id) => {
  try {
    const response = await api.get(`/api/images/design/${design_id}`);
    const filteredData = response.data
      .filter((item) => !!item?.image_with_padding)
      .sort((a, b) => b.id - a.id);

    return filteredData;
  } catch (error) {
    // Log the error for debugging purposes
    console.error("Error fetching design segmentations:", error);

    // Handle different types of errors
    let errorMessage = "An error occurred while fetching the design segmentations.";

    if (error.response) {
      // The request was made and the server responded with a status code that is not in the 2xx range
      errorMessage += ` Server responded with status: ${error.response.status} - ${error.response.statusText}.`;
    } else if (error.request) {
      // The request was made but no response was received
      errorMessage += " No response received from the server.";

      // Check for CORS error
      if (!error.response && error.message === "Network Error") {
        errorMessage += " This might be a CORS issue. Please check your server CORS policy.";
      }
    } else {
      // Something happened in setting up the request that triggered an error
      errorMessage += ` Error: ${error.message}.`;
    }

    // Show the browser alert with the error message
    toast.error(errorMessage);

    // Return an empty array to ensure the function returns something valid
    return [];
  }
};

export const getOrderSegmentations = async (order_id) => {
  return api
    .get(`/api/images/order/${order_id}`)
    .then((res) =>
      res.data.filter((item) => !!item?.image_with_padding).sort((a, b) => b.id - a.id)
    )
    .catch(() => []);
};

export const postProcessImage = async ({ order_id, design_id, cropType = "pet", file }) => {
  const formData = new FormData();
  formData.append("original_image", file);
  formData.append("order_id", order_id);
  formData.append("design_id", design_id);
  formData.append("type", cropType);

  return startSpan({ name: "POST mad-unicorn image" }, async () => {
    try {
      const response = await api.post("api/image/process", formData);
      return response.data;
    } catch (error) {
      // Log the error for debugging purposes
      console.error("Error posting image process data:", error);

      // Handle different types of errors
      let errorMessage = "An error occurred while processing the image.";

      if (error.response) {
        // The request was made and the server responded with a status code not in the 2xx range
        errorMessage += ` Server responded with status: ${error.response.status} - ${error.response.statusText}.`;
      } else if (error.request) {
        // The request was made but no response was received
        errorMessage += " No response received from the server.";

        // Check for CORS error
        if (!error.response && error.message === "Network Error") {
          errorMessage += " This might be a CORS issue. Please check your server CORS policy.";
        }
      } else {
        // Something happened in setting up the request that triggered an error
        errorMessage += ` Error: ${error.message}.`;
      }

      // Show the browser alert with the error message
      toast.error(errorMessage);

      // Return null or handle it appropriately so the function does not break
      return null;
    }
  });
};

export const postProcessImage64 = async ({ order_id, design_id, cropType = "pet", file }) => {
  return startSpan({ name: "POST mad-unicorn image 64" }, async () => {
    try {
      const response = await api.post(
        "api/image/process64",
        { order_id, design_id, type: cropType, original_image: file },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      // Log the error for debugging purposes
      console.error("Error posting image process data:", error);

      // Handle different types of errors
      let errorMessage = "An error occurred while processing the image.";

      if (error.response) {
        // The request was made and the server responded with a status code not in the 2xx range
        errorMessage += ` Server responded with status: ${error.response.status} - ${error.response.statusText}.`;
      } else if (error.request) {
        // The request was made but no response was received
        errorMessage += " No response received from the server.";

        // Check for CORS error
        if (!error.response && error.message === "Network Error") {
          errorMessage += " This might be a CORS issue. Please check your server CORS policy.";
        }
      } else {
        // Something happened in setting up the request that triggered an error
        errorMessage += ` Error: ${error.message}.`;
      }

      // Show the browser alert with the error message
      toast.error(errorMessage);

      // Return null or handle it appropriately so the function does not break
      return null;
    }
  });
};

export const putStringHole = async ({ id, position }) => {
  const resp = await api.put(
    `/api/images/${id}/draw`,
    { position },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return resp.data;
};
